// Features/Line-Item/Animations/Checkmark.ts
function runCheckmark({ target }) {
  return target.animate({
    opacity: [0, 1],
    transform: ["translateY(10px)", "translateY(0)"]
  }, {
    duration: 75,
    endDelay: 300
  });
}
// Features/Line-Item/Animations/Disappear.ts
function runDisappear({ target }) {
  return target.animate({
    opacity: [1, 0],
    height: [`${target.clientHeight}px`, String(0)]
  }, {
    duration: 300,
    easing: "ease"
  });
}
// Features/Line-Item/Animations/Spin.ts
function runSpin({ target }) {
  return target.animate({
    opacity: [1, 0],
    transform: ["translateY(0)", "translateY(-10px)"]
  }, 75);
}
// Features/Line-Item/Component.ts
var Selector_Loader = `.line-item__loader`;

class LineItem extends HTMLElement {
  loader;
  constructor() {
    super();
    this.loader = this.querySelector(Selector_Loader);
    this.addEventListener(`Line-Item-Quantity:Change:Start`, this.onQuantityStart.bind(this));
    this.addEventListener(`Line-Item-Quantity:Change:End`, this.onQuantityEnd.bind(this));
  }
  get productId() {
    return Number(this.dataset.product);
  }
  get variantId() {
    return Number(this.dataset.variant);
  }
  get key() {
    return this.dataset.key;
  }
  get spinner() {
    return this.loader.firstElementChild;
  }
  get checkmark() {
    return this.loader.lastElementChild;
  }
  onQuantityStart() {
    this.checkmark.hidden = true;
    this.spinner.hidden = false;
    this.loader.hidden = false;
  }
  async onQuantityEnd(event) {
    if (event.detail.cart.item_count === 0)
      return;
    await this.runSpin();
    this.spinner.hidden = true;
    if (event.detail.newLineQuantity === 0) {
      await this.runDisappear();
      this.remove();
    } else {
      this.checkmark.hidden = false;
      await this.runCheckmark();
      this.loader.hidden = true;
    }
  }
  async runSpin() {
    return await runSpin({ target: this.spinner }).finished;
  }
  async runDisappear() {
    return await runDisappear({ target: this }).finished;
  }
  async runCheckmark() {
    return await runCheckmark({ target: this.checkmark }).finished;
  }
}

// Features/Line-Item/mod.ts
window.customElements.define("line-item", LineItem);
